import { RidangoReduxAction } from "@ridango/core";
import { tassign } from "tassign";
import { IsicCardActions } from "./isic-card.actions";

export interface IsicCardState {
    error: any;
    isicCardFinished: boolean;
    isicCardLoading: boolean;
};

export const ISIC_CARD_INITIAL_STATE: IsicCardState = {
    error: null,
    isicCardFinished: false,
    isicCardLoading: false,
};

export const ISIC_CARD_STATE_KEY = 'isic-card';

export function isicCardReducer(
    lastState: IsicCardState = ISIC_CARD_INITIAL_STATE,
    action: RidangoReduxAction
): IsicCardState {
    const normalized = {};

    switch (action.type) {
        case IsicCardActions.ACTIVATE_ISIC_CARD:
            return tassign(lastState, {
                isicCardFinished: false,
            });
        case IsicCardActions.ACTIVATE_ISIC_CARD_SUCCESS:
            return tassign(lastState, {
                ...action.payload,
                isicCardFinished: true,
                error: null,
            });
        case IsicCardActions.ACTIVATE_ISIC_CARD_FAILED:
            return tassign(lastState, {
                error: action.payload,
                isicCardFinished: true,
            });
        case IsicCardActions.SET_ISIC_CARD_ACTIVATION_LOADING:
            return tassign(lastState, {
                isicCardLoading: action.payload,
            });
    }
    return lastState;
}

export interface IsicCardPartialStoreState {
    [ISIC_CARD_STATE_KEY]: IsicCardState;
}




